import tags from '../tags';

const {
  elements: { fire, lightning, physical, holy },
  skillTypes: {
    healing,
    cc,
    dot,
    weaken,
    resource,
    cooldown,
    damageBoost,
    toughness,
    mobility,
    pet,
  },
  skillTrees: { primary, secondary, defensive, utility, laws, conviction },
} = tags;

export default [
  {
    name: 'Punish',
    runes: [
      {
        name: 'No rune',
        tags: [primary, physical, toughness],
      },
      {
        name: 'Roar',
        tags: [primary, fire, toughness],
      },
      {
        name: 'Celerity',
        tags: [primary, physical, toughness, damageBoost],
      },
      {
        name: 'Rebirth',
        tags: [primary, physical, toughness, healing],
      },
      {
        name: 'Retaliate',
        tags: [primary, holy, toughness],
      },
      {
        name: 'Fury',
        tags: [primary, lightning, toughness, damageBoost],
      },
    ],
  },
  {
    name: 'Shield Bash',
    runes: [
      {
        name: 'No rune',
        tags: [secondary, holy],
      },
      {
        name: 'Shattered Shield',
        tags: [secondary, holy],
      },
      {
        name: 'One on One',
        tags: [secondary, lightning, cc],
      },
      {
        name: 'Shield Cross',
        tags: [secondary, physical],
      },
      {
        name: 'Crumble',
        tags: [secondary, fire],
      },
      {
        name: 'Pound',
        tags: [secondary, physical],
      },
    ],
  },
  {
    name: 'Slash',
    runes: [
      {
        name: 'No rune',
        tags: [primary, fire],
      },
      {
        name: 'Electrify',
        tags: [primary, lightning, cc],
      },
      {
        name: 'Carve',
        tags: [primary, fire],
      },
      {
        name: 'Crush',
        tags: [primary, fire],
      },
      {
        name: 'Zeal',
        tags: [primary, holy, damageBoost],
      },
      {
        name: 'Guard',
        tags: [primary, fire, toughness],
      },
    ],
  },
  {
    name: 'Shield Glare',
    runes: [
      {
        name: 'No rune',
        tags: [defensive, cc, holy],
      },
      {
        name: 'Divine Verdict',
        tags: [defensive, cc, weaken, holy],
      },
      {
        name: 'Uncertainty',
        tags: [defensive, cc, holy],
      },
      {
        name: 'Zealous Glare',
        tags: [defensive, cc, resource, holy],
      },
      {
        name: 'Emblazoned Shield',
        tags: [defensive, cc, physical],
      },
      {
        name: 'Subdue',
        tags: [defensive, cc, holy],
      },
    ],
  },
  {
    name: 'Sweep Attack',
    runes: [
      {
        name: 'No rune',
        tags: [secondary, physical],
      },
      {
        name: 'Blazing Sweep',
        tags: [secondary, fire, dot],
      },
      {
        name: 'Trip Attack',
        tags: [secondary, lightning, cc],
      },
      {
        name: 'Holy Shock',
        tags: [secondary, physical, healing],
      },
      {
        name: 'Gathering Sweep',
        tags: [secondary, holy, cc],
      },
      {
        name: 'Inspiring Sweep',
        tags: [secondary, holy, toughness],
      },
    ],
  },
  {
    name: 'Iron Skin',
    runes: [
      {
        name: 'No rune',
        tags: [defensive, toughness, physical],
      },
      {
        name: 'Reflective Skin',
        tags: [defensive, toughness, physical],
      },
      {
        name: 'Steel Skin',
        tags: [defensive, toughness, physical],
      },
      {
        name: 'Explosive Skin',
        tags: [defensive, toughness, physical],
      },
      {
        name: 'Charged Up',
        tags: [defensive, toughness, cc, lightning],
      },
      {
        name: 'Flash',
        tags: [defensive, toughness, mobility, lightning],
      },
    ],
  },
  {
    name: 'Provoke',
    runes: [
      {
        name: 'No rune',
        tags: [utility, cc, resource, physical],
      },
      {
        name: 'Cleanse',
        tags: [utility, cc, resource, healing, physical],
      },
      {
        name: 'Flee Fool',
        tags: [utility, cc, resource, physical],
      },
      {
        name: 'Too Scared to Run',
        tags: [utility, cc, resource, weaken, physical],
      },
      {
        name: 'Charged Up',
        tags: [utility, cc, resource, lightning],
      },
      {
        name: 'Hit Me',
        tags: [utility, cc, resource, toughness, physical],
      },
    ],
  },
  {
    name: 'Smite',
    runes: [
      {
        name: 'No rune',
        tags: [primary, holy],
      },
      {
        name: 'Shatter',
        tags: [primary, holy],
      },
      {
        name: 'Shackle',
        tags: [primary, holy, cc],
      },
      {
        name: 'Surge',
        tags: [primary, holy],
      },
      {
        name: 'Reaping',
        tags: [primary, holy, healing],
      },
      {
        name: 'Shared Fate',
        tags: [primary, lightning, cc],
      },
    ],
  },
  {
    name: 'Blessed Hammer',
    runes: [
      {
        name: 'No rune',
        tags: [secondary, holy],
      },
      {
        name: 'Burning Wrath',
        tags: [secondary, fire],
      },
      {
        name: 'Thunderstruck',
        tags: [secondary, lightning],
      },
      {
        name: 'Limitless',
        tags: [secondary, holy],
      },
      {
        name: 'Brute Force',
        tags: [secondary, physical, cc],
      },
      {
        name: 'Dominion',
        tags: [secondary, holy],
      },
    ],
  },
  {
    name: 'Steed Charge',
    runes: [
      {
        name: 'No rune',
        tags: [utility, mobility, physical],
      },
      {
        name: 'Spiked Barding',
        tags: [utility, mobility, physical],
      },
      {
        name: 'Nightmare',
        tags: [utility, mobility, fire],
      },
      {
        name: 'Rejuvenation',
        tags: [utility, mobility, healing, physical],
      },
      {
        name: 'Endurance',
        tags: [utility, mobility, physical],
      },
      {
        name: 'Draw and Quarter',
        tags: [utility, mobility, holy],
      },
    ],
  },
  {
    name: 'Laws of Valor',
    runes: [
      {
        name: 'No rune',
        tags: [laws, damageBoost, physical],
      },
      {
        name: 'Invincible',
        tags: [laws, damageBoost, healing, physical],
      },
      {
        name: 'Frozen in Terror',
        tags: [laws, damageBoost, cc, physical],
      },
      {
        name: 'Critical',
        tags: [laws, damageBoost, physical],
      },
      {
        name: 'Unstoppable Force',
        tags: [laws, damageBoost, resource, physical],
      },
      {
        name: 'Answered Prayer',
        tags: [laws, damageBoost, physical],
      },
    ],
  },
  {
    name: 'Justice',
    runes: [
      {
        name: 'No rune',
        tags: [primary, holy],
      },
      {
        name: 'Burst',
        tags: [primary, lightning, cc],
      },
      {
        name: 'Crack',
        tags: [primary, holy],
      },
      {
        name: 'Hammer of Pursuit',
        tags: [primary, physical],
      },
      {
        name: 'Sword of Justice',
        tags: [primary, physical, damageBoost],
      },
      {
        name: 'Holy Bolt',
        tags: [primary, holy, healing],
      },
    ],
  },
  {
    name: 'Consecration',
    runes: [
      {
        name: 'No rune',
        tags: [defensive, healing, holy],
      },
      {
        name: 'Bathed in Light',
        tags: [defensive, healing, holy],
      },
      {
        name: 'Bed of Nails',
        tags: [defensive, healing, physical],
      },
      {
        name: 'Aegis Purgatory',
        tags: [defensive, healing, cc, holy],
      },
      {
        name: 'Shattered Ground',
        tags: [defensive, healing, fire, fire],
      },
      {
        name: 'Fearful',
        tags: [defensive, healing, cc, holy],
      },
    ],
  },
  {
    name: 'Laws of Justice',
    runes: [
      {
        name: 'No rune',
        tags: [laws, toughness, physical],
      },
      {
        name: 'Protect the Innocent',
        tags: [laws, toughness, physical],
      },
      {
        name: 'Immovable Object',
        tags: [laws, toughness, physical],
      },
      {
        name: "Faith's Armor",
        tags: [laws, toughness, physical],
      },
      {
        name: 'Decaying Strength',
        tags: [laws, toughness, weaken, physical],
      },
      {
        name: 'Bravery',
        tags: [laws, toughness, mobility, physical],
      },
    ],
  },
  {
    name: 'Falling Sword',
    runes: [
      {
        name: 'No rune',
        tags: [conviction, physical, mobility],
      },
      {
        name: 'Superheated',
        tags: [conviction, fire, mobility],
      },
      {
        name: 'Part the Clouds',
        tags: [conviction, lightning, mobility, cc],
      },
      {
        name: 'Rise Brothers',
        tags: [conviction, physical, mobility, pet],
      },
      {
        name: 'Rapid Descent',
        tags: [conviction, lightning, mobility, cooldown],
      },
      {
        name: 'Flurry',
        tags: [conviction, holy, mobility, cc],
      },
    ],
  },
  {
    name: 'Blessed Shield',
    runes: [
      {
        name: 'No rune',
        tags: [secondary, holy],
      },
      {
        name: 'Staggering Shield',
        tags: [secondary, lightning, cc],
      },
      {
        name: 'Combust',
        tags: [secondary, fire],
      },
      {
        name: 'Divine Aegis',
        tags: [secondary, physical, toughness, healing],
      },
      {
        name: 'Shattering Throw',
        tags: [secondary, holy],
      },
      {
        name: 'Piercing Shield',
        tags: [secondary, holy, cc],
      },
    ],
  },
  {
    name: 'Condemn',
    runes: [
      {
        name: 'No rune',
        tags: [utility, holy],
      },
      {
        name: 'Vacuum',
        tags: [utility, holy, cc],
      },
      {
        name: 'Unleashed',
        tags: [utility, holy],
      },
      {
        name: 'Eternal Retaliation',
        tags: [utility, holy, cooldown],
      },
      {
        name: 'Shattering Explosion',
        tags: [utility, physical],
      },
      {
        name: 'Reciprocate',
        tags: [utility, fire],
      },
    ],
  },
  {
    name: 'Judgment',
    runes: [
      {
        name: 'No rune',
        tags: [defensive, cc, physical],
      },
      {
        name: 'Penitence',
        tags: [defensive, cc, healing, physical],
      },
      {
        name: 'Mass Verdict',
        tags: [defensive, cc, physical],
      },
      {
        name: 'Deliberation',
        tags: [defensive, cc, physical],
      },
      {
        name: 'Resolved',
        tags: [defensive, cc, weaken, physical],
      },
      {
        name: 'Debilitate',
        tags: [defensive, cc, weaken, physical],
      },
    ],
  },
  {
    name: 'Laws of Hope',
    runes: [
      {
        name: 'No rune',
        tags: [laws, healing, toughness, physical],
      },
      {
        name: 'Wings of Angels',
        tags: [laws, healing, toughness, mobility, physical],
      },
      {
        name: 'Eternal Hope',
        tags: [laws, healing, toughness, physical],
      },
      {
        name: 'Hopeful Cry',
        tags: [laws, healing, toughness, physical],
      },
      {
        name: "Faith's Reward",
        tags: [laws, healing, toughness, physical],
      },
      {
        name: 'Promise of Faith',
        tags: [laws, healing, toughness, physical],
      },
    ],
  },
  {
    name: "Akarat's Champion",
    runes: [
      {
        name: 'No rune',
        tags: [conviction, damageBoost, resource, fire],
      },
      {
        name: 'Fire Starter',
        tags: [conviction, damageBoost, resource, fire, dot],
      },
      {
        name: 'Embodiment of Power',
        tags: [conviction, damageBoost, resource, physical],
      },
      {
        name: 'Rally',
        tags: [conviction, damageBoost, resource, cooldown, lightning],
      },
      {
        name: 'Prophet',
        tags: [conviction, damageBoost, resource, toughness, holy],
      },
      {
        name: 'Hasteful',
        tags: [conviction, damageBoost, resource, holy],
      },
    ],
  },
  {
    name: 'Fist of the Heavens',
    runes: [
      {
        name: 'No rune',
        tags: [secondary, lightning],
      },
      {
        name: 'Divine Well',
        tags: [secondary, holy],
      },
      {
        name: "Heaven's Tempest",
        tags: [secondary, fire],
      },
      {
        name: 'Fissure',
        tags: [secondary, lightning],
      },
      {
        name: 'Reverberation',
        tags: [secondary, lightning, cc],
      },
      {
        name: 'Retribution',
        tags: [secondary, holy],
      },
    ],
  },
  {
    name: 'Phalanx',
    runes: [
      {
        name: 'No rune',
        tags: [utility, pet, physical],
      },
      {
        name: 'Bowmen',
        tags: [utility, pet, physical],
      },
      {
        name: 'Shield Charge',
        tags: [utility, pet, physical],
      },
      {
        name: 'Stampede',
        tags: [utility, pet, physical, cc],
      },
      {
        name: 'Shield Bearers',
        tags: [utility, pet, physical, cc],
      },
      {
        name: 'Bodyguard',
        tags: [utility, pet, physical],
      },
    ],
  },
  {
    name: "Heaven's Fury",
    runes: [
      {
        name: 'No rune',
        tags: [conviction, holy, dot],
      },
      {
        name: 'Blessed Ground',
        tags: [conviction, holy, dot],
      },
      {
        name: 'Ascendancy',
        tags: [conviction, holy, dot],
      },
      {
        name: 'Split Fury',
        tags: [conviction, holy, dot],
      },
      {
        name: 'Thou Shalt Not Pass',
        tags: [conviction, lightning, dot, cc],
      },
      {
        name: 'Fires of Heaven',
        tags: [conviction, holy],
      },
    ],
  },
  {
    name: 'Bombardment',
    runes: [
      {
        name: 'No rune',
        tags: [conviction, physical],
      },
      {
        name: 'Barrels of Spikes',
        tags: [conviction, physical],
      },
      {
        name: 'Annihilate',
        tags: [conviction, fire],
      },
      {
        name: 'Mine Field',
        tags: [conviction, fire],
      },
      {
        name: 'Impactful Bombardment',
        tags: [conviction, physical],
      },
      {
        name: 'Targeted',
        tags: [conviction, holy],
      },
    ],
  },
];
